import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../../hooks';
import styles from './Footer.module.css';

/**
 * Footer Component
 * 
 * Site footer with copyright information, contact details, and navigation links.
 * Includes proper accessibility attributes and responsive design.
 * 
 * Features:
 * - Copyright information with dynamic year
 * - Contact email link
 * - Privacy policy navigation
 * - Responsive design
 * - CSS Modules for scoped styling
 * - Accessibility compliance
 * 
 * @component
 * @example
 * return (
 *   <Footer />
 * )
 */
const Footer = () => {
  const { t, language } = useTranslation();
  
  return (
    <footer className={styles.footer} role="contentinfo">
      <div className={styles.container}>
        {/* Copyright Information */}
        <div className={styles.copyright}>
          &copy; {new Date().getFullYear()} {t.footer.copyright}
        </div>
        
        {/* Contact Information */}
        <div className={styles.contact}>
          {t.footer.contact}{' '}
          <a 
            href="mailto:Info@QaqaaiyatAlJiser.com" 
            className={styles.contactLink}
            aria-label={language === 'ar' ? 'إرسال بريد إلكتروني إلى Info@QaqaaiyatAlJiser.com' : 'Send email to Info@QaqaaiyatAlJiser.com'}
          >
            Info@QaqaaiyatAlJiser.com
          </a>
        </div>
        
        {/* Navigation Links */}
        <div className={styles.navigation}>
          <Link 
            to="/privacy-policy" 
            className={styles.navLink}
            aria-label={language === 'ar' ? 'عرض سياسة الخصوصية' : 'View Privacy Policy'}
          >
            {language === 'ar' ? 'سياسة الخصوصية' : 'Privacy Policy'}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;